import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IOrderGroupRepository } from '@/coreInfrastructureModule/interfaces/IOrderGroupRepository';
import { BulkPostOrderToOrderGroupAdapter } from '../adapters/bulkPostOrderToOrderGroupAdapter';

/**
 * 複数の発注を発注グループに紐づけるユースケース
 */
export class BulkPostOrderToOrderGroupUseCase {
  private repository: IOrderGroupRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderGroupRepository) {
    this.repository = repository;
  }

  /**
   * 複数の発注を発注グループに紐づける
   * @param orderGroupId - 発注グループID
   * @param orderIds - 複数の発注ID
   * @param eta - 変更する納期
   */
  public execute = async (orderGroupId: string, orderIds: string[], eta?: number): Promise<INetworkResult<undefined, Error>> => {
    try {
      const request = BulkPostOrderToOrderGroupAdapter.adapt(orderGroupId, orderIds, eta);
      const response = await this.repository.postBulkOrderToOrderGroup(request);
      switch (response.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: undefined,
            },
          };
        case 'error':
          throw response.status.error;
        default:
          throw new Error('unexpected Error');
      }
    } catch (e) {
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  };
}
